import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "C:/nexus/data-gh/guide/src/components/layout/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`1. Don't use `}<inlineCode parentName="h2">{`var`}</inlineCode></h2>
    <p>{`When looking at older javascript code, you'll see variables created with `}<inlineCode parentName="p">{`var`}</inlineCode>{`. Don't use `}<inlineCode parentName="p">{`var`}</inlineCode>{` to create variables.`}</p>
    <p>{`Most of the time, we won't need to change the values of a variable, so default to creating things using `}<inlineCode parentName="p">{`const`}</inlineCode>{`. If you do need to change the value, use `}<inlineCode parentName="p">{`let`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`var`}</inlineCode>{`.`}</p>
    <h2>{`2. Functions`}</h2>
    <p>{`When creating functions please use the arrow notation (`}<inlineCode parentName="p">{`() => {}`}</inlineCode>{`). If we need to call this function later, we can assign it to a const.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const sum = (a, b) => {
    return a + b
}

sum(1, 2) // 3
`}</code></pre>
    <p>{`Since there is only one line and we're returning a value, this can be shortened, removing the curly brackets and the return. The following function is identical.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const sum = (a, b) => a + b

sum(1, 2) // 3
`}</code></pre>
    <p>{`Converting to this shorthand should be done automatically in our projects with ESLint installed.`}</p>
    <p>{`When returing an object, you can still use the shorthand, just wrap the curly brackets in parenthesis.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const createPerson = (name) => ({ name })

createPerson("labyrinth") // { name: "labyrinth" }
`}</code></pre>
    <h2>{`3. Always use `}<inlineCode parentName="h2">{`===`}</inlineCode></h2>
    <p>{`Using strict equality (`}<inlineCode parentName="p">{`===`}</inlineCode>{`) checks that the values `}<em parentName="p">{`and`}</em>{` the types of what you're comparing are the same. This should always be preferred over the loose equality `}<inlineCode parentName="p">{`==`}</inlineCode>{`.`}</p>
    <p>{`Your code will be more readable and you can avoid potential errors if you don't abuse truthy and falsy values.`}</p>
    <h2>{`4. Have descriptive id's and class names`}</h2>
    <p>{`Eventually, our charts will go on the dailynexus.com website, which has it's on CSS styles, id's and class names. We need to make sure that the id's and class names we use don't overlap with other elements on the website.`}</p>
    <p>{`When creating id's and class names, make them descriptive! Please use this scheme below:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`laby-(project-name)-(chart-name)-element
`}</code></pre>
    <p>{`For example, if I have a project that we're calling the 'senate-tracker' and I'm making a bar chart showing the number of votes each person got for a specific position, we can call this chart the 'position-votes-chart', then the id I should assign to the container div is: 'laby-senate-tracker-position-votes-chart'.`}</p>
    <p>{`If in this bar chart, I'm making an arrow and need an id with the triangle, I should use the id, 'laby-senate-tracker-position-votes-chart-triangle'. If the id was just 'triangle' then it's going to mess up the COVID tracker on the sidebar of the page because I'm already using that ID.`}</p>
    <p>{`If you have to use these classes or id's multiple times throughout your code, just save the long names to a variable so it's more managable. It is important that the id's and classnames in the html is descriptive and unique!`}</p>
    <h2>{`5. D3 imports`}</h2>
    <p>{`In other places on the web, you'll see people write code like:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`d3.select('#plot-id');
`}</code></pre>
    <p>{`We don't want to be importing all of D3 because then we'll be including a lot of code that we aren't using. Instead, just import the specific functions that we are using. So the code above should be changed to:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// goes at the top of the file:
import { select } from 'd3-selection'

select('#plot-id')
`}</code></pre>
    <p>{`Reference `}<Link to="../d3/imports" mdxType="Link">{`this page`}</Link>{` to see which functions come from which submodules.`}</p>
    <h2>{`6. Use D3 Dates`}</h2>
    <p>{`Dates in Javascript are annoying to use and have cross-browser compatability issues. Look at `}<inlineCode parentName="p">{`d3.timeParse()`}</inlineCode>{` and `}<inlineCode parentName="p">{`d3.timeFormat()`}</inlineCode>{`.`}</p>
    <h2>{`7. ESLint Ignore`}</h2>
    <p>{`Our Prettier-ESLint plugin will format your code, make some transformations (such as changing `}<inlineCode parentName="p">{`var`}</inlineCode>{` to `}<inlineCode parentName="p">{`let`}</inlineCode>{` or `}<inlineCode parentName="p">{`const`}</inlineCode>{`) and show warnings and errors. If there are yellow or red squiggly lines, please read the message and take the steps to correct it. Please do not just add a comment to ignore the warning or error.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      